export function OutlineTrashSlashIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.17407 3.1776C8.42367 3.0624 8.70207 3 8.99487 3H14.9997C16.1037 3 16.9965 3.8976 16.9965 4.9968V7.0032H11.9997"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9983 15.9991L19.1615 19.1623V19.1863C19.0703 20.2135 18.2063 21.0007 17.1743 21.0007H6.82069C5.78869 21.0007 4.92949 20.2135 4.83349 19.1863L3.99829 10.0039V7.00391H7.00309L15.9983 15.9991Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9998 7.00391H19.9966V10.0039L19.579 14.5831"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9998 17.0016V12"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9983 17.0012V15.998"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99658 11.002V17.002"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9998 7.00391H19.9966H16.9966H11.9998"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.00296 7.00391H6.99816H3.99816H2.99976"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.99976 3L6.99816 6.9984V7.0032H7.00296L11.9998 12L15.9982 15.9984L19.1614 19.1616L20.9998 21"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
